/**
 * @ngdoc service
 * @name posApp.posInit
 * Service that is injected to set up pos dependecies
 */
angular
  .module('posApp')
  .service(
    'posInit',
    (
      $rootScope: ng.IRootScopeService,
      legacy,
      pos,
      translate: ng.translate.ITranslateService,
    ) => {
      const $translate = translate,
        posInit = {
          pageRef: 'pos.route#pos',
          customerHasOpenCoupons: false,
        };

      /*
       * Listens for customer selection to update the transaction
       */
      // TODO move to new service
      $rootScope.$on('customerSelected', (l, customer) => {
        //Save the customer data to the receipt client
        pos.setTransactionDetails(pos.transaction, null, null, customer);
      });

      // Listens to check if a customer has open coupons
      // TODO move to pos service
      $rootScope.$on('posGetCustomerOpenCoupons', (l, id) => {
        posInit.customerHasOpenCoupons = false;
        if (id) {
          legacy.getOpenCouponsByCustomer(id).then(
            (response) => {
              posInit.customerHasOpenCoupons = response.response;
            },
            () => {
              // If FoxPro api error thrown, assume false
              posInit.customerHasOpenCoupons = false;
            },
          );
        }
      });

      return posInit;
    },
  );
